import React, { memo, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { CategoryLandingPageSectionBlokProps } from './CategoryLandingPage';
import { formatStringForUrl } from '../../utils/formatStringForUrl/formatStringForUrl.util';

interface CategoryLandingPageSideBarMobileDropdownItemProps {
  categoryLandingPageSection: CategoryLandingPageSectionBlokProps;
  isLastItem: boolean;
  itemIdx: number;
  activeCategoryLandingPageSection: string;
  setActiveCategoryLandingPageSection: (state: string) => void;
}

const CategoryLandingPageSideBarMobileDropdownItem: React.FC<
  CategoryLandingPageSideBarMobileDropdownItemProps
> = ({
  categoryLandingPageSection,
  isLastItem,
  itemIdx,
  activeCategoryLandingPageSection,
  setActiveCategoryLandingPageSection,
}) => {
  const isActive =
    activeCategoryLandingPageSection ===
    formatStringForUrl(categoryLandingPageSection.heading);

  const handleClick = () => {
    const section = formatStringForUrl(categoryLandingPageSection.heading);
    setActiveCategoryLandingPageSection(section);
    window.location.hash = `#${section}`;
  };

  return (
    <li
      className={classNames({
        'border-b border-b-border/light': !isLastItem,
      })}
    >
      <button
        className="py-3 relative flex items-center justify-start gap-x-4 group"
        onClick={handleClick}
      >
        <div
          className={classNames(
            'w-6 h-6 rounded-full flex items-center justify-center transition-colors ease-in-out duration-100',
            {
              'bg-[#E5F4F9] text-text/body-accent group-hover:bg-text/body-accent group-hover:text-system/white':
                !isActive,
              'bg-text/body-accent text-system/white': isActive,
            }
          )}
        >
          <p className={'font-dm-serif-display'}>{itemIdx + 1}</p>
        </div>
        <p
          className={classNames({
            'text-text/body-accent': isActive,
            'text-text/body-tint group-hover:text-text/body-accent': !isActive,
          })}
        >
          {categoryLandingPageSection?.heading}
        </p>
        {isActive && (
          <div className="absolute top-0 right-0 bottom-0 left-0 bg-system/white/75"></div>
        )}
      </button>
    </li>
  );
};

export default CategoryLandingPageSideBarMobileDropdownItem;
